module.exports = __webpack_public_path__ + "static/media/history_25.1a913976.jpg";